import {
  Input,
  OnInit,
  Output,
  Component,
  OnChanges,
  EventEmitter,
  ViewEncapsulation, SimpleChanges,
} from '@angular/core';

import {
  IOutlet,
  IScheduleOverride,
  OUTLET_SCHEDULE_TYPES,
  mapSpecialOpeningTimes,
  IOutletAccordionOptions,
  IFormattedOutletSchedule,
  OUTLET_FORMATTED_SCHEDULE_TYPES, ngHelper,
} from '@cakeiteasy/web-utils';
import { TranslateModule } from '@ngx-translate/core';

import { UiAccordionOutletMapComponent } from '../ui-accordion-outlet-map/ui-accordion-outlet-map.component';

@Component({
  standalone: true,
  selector: 'ui-accordion-outlet',
  templateUrl: './ui-accordion-outlet.component.html',
  styleUrls: ['./ui-accordion-outlet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, UiAccordionOutletMapComponent],
})
export class UiAccordionOutletComponent implements OnInit, OnChanges {
  @Input() outlet: any;
  @Input() scheduleOverrides: IScheduleOverride[] = [];
  @Input() showNext: boolean;
  @Input() nextText: string;
  @Input() options: IOutletAccordionOptions;
  @Input() scheduleType: string = OUTLET_SCHEDULE_TYPES.WORKING_DAYS;
  @Input() hideNextButton = false;

  @Output() onNext = new EventEmitter<IOutlet>();

  openingTime: { dateRange: string, time: string | null, isClosed: boolean }[] = [];
  formattedSchedule: IFormattedOutletSchedule[];
  OUTLET_SCHEDULE_TYPES = OUTLET_SCHEDULE_TYPES;

  ngOnInit() {
    this.formattedSchedule = this.outlet[OUTLET_FORMATTED_SCHEDULE_TYPES[this.scheduleType]];
  }

  ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'scheduleOverrides', (scheduleOverrides) => {
      this.openingTime = mapSpecialOpeningTimes(scheduleOverrides || []);
    });
  }
}
